/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EligibilityCheckRequestObject } from './EligibilityCheckRequestObject';
import {
    EligibilityCheckRequestObjectFromJSON,
    EligibilityCheckRequestObjectFromJSONTyped,
    EligibilityCheckRequestObjectToJSON,
} from './EligibilityCheckRequestObject';
import type { RoutedEligibilityInsuranceContext } from './RoutedEligibilityInsuranceContext';
import {
    RoutedEligibilityInsuranceContextFromJSON,
    RoutedEligibilityInsuranceContextFromJSONTyped,
    RoutedEligibilityInsuranceContextToJSON,
} from './RoutedEligibilityInsuranceContext';

/**
 * 
 * @export
 * @interface PerformEligibilityCheckRequest
 */
export interface PerformEligibilityCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof PerformEligibilityCheckRequest
     */
    selected_payer_source?: PerformEligibilityCheckRequestSelectedPayerSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PerformEligibilityCheckRequest
     */
    selected_payer_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PerformEligibilityCheckRequest
     */
    lead_insurance_id?: string;
    /**
     * 
     * @type {RoutedEligibilityInsuranceContext}
     * @memberof PerformEligibilityCheckRequest
     */
    insurance_context?: RoutedEligibilityInsuranceContext;
    /**
     * 
     * @type {EligibilityCheckRequestObject}
     * @memberof PerformEligibilityCheckRequest
     */
    eligibility_request: EligibilityCheckRequestObject;
    /**
     * 
     * @type {string}
     * @memberof PerformEligibilityCheckRequest
     */
    coverage_priority: string;
    /**
     * Whether memberIdentifier is an MBI or SSN. Defaults to MBI.
     * @type {string}
     * @memberof PerformEligibilityCheckRequest
     */
    member_identifier_type?: PerformEligibilityCheckRequestMemberIdentifierTypeEnum;
}


/**
 * @export
 */
export const PerformEligibilityCheckRequestSelectedPayerSourceEnum = {
    Stedi: 'stedi',
    Inovalon: 'inovalon'
} as const;
export type PerformEligibilityCheckRequestSelectedPayerSourceEnum = typeof PerformEligibilityCheckRequestSelectedPayerSourceEnum[keyof typeof PerformEligibilityCheckRequestSelectedPayerSourceEnum];

/**
 * @export
 */
export const PerformEligibilityCheckRequestMemberIdentifierTypeEnum = {
    Mbi: 'MBI',
    Ssn: 'SSN'
} as const;
export type PerformEligibilityCheckRequestMemberIdentifierTypeEnum = typeof PerformEligibilityCheckRequestMemberIdentifierTypeEnum[keyof typeof PerformEligibilityCheckRequestMemberIdentifierTypeEnum];


/**
 * Check if a given object implements the PerformEligibilityCheckRequest interface.
 */
export function instanceOfPerformEligibilityCheckRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eligibility_request" in value;
    isInstance = isInstance && "coverage_priority" in value;

    return isInstance;
}

export function PerformEligibilityCheckRequestFromJSON(json: any): PerformEligibilityCheckRequest {
    return PerformEligibilityCheckRequestFromJSONTyped(json, false);
}

export function PerformEligibilityCheckRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformEligibilityCheckRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selected_payer_source': !exists(json, 'selected_payer_source') ? undefined : json['selected_payer_source'],
        'selected_payer_id': !exists(json, 'selected_payer_id') ? undefined : json['selected_payer_id'],
        'lead_insurance_id': !exists(json, 'lead_insurance_id') ? undefined : json['lead_insurance_id'],
        'insurance_context': !exists(json, 'insurance_context') ? undefined : RoutedEligibilityInsuranceContextFromJSON(json['insurance_context']),
        'eligibility_request': EligibilityCheckRequestObjectFromJSON(json['eligibility_request']),
        'coverage_priority': json['coverage_priority'],
        'member_identifier_type': !exists(json, 'member_identifier_type') ? undefined : json['member_identifier_type'],
    };
}

export function PerformEligibilityCheckRequestToJSON(value?: PerformEligibilityCheckRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected_payer_source': value.selected_payer_source,
        'selected_payer_id': value.selected_payer_id,
        'lead_insurance_id': value.lead_insurance_id,
        'insurance_context': RoutedEligibilityInsuranceContextToJSON(value.insurance_context),
        'eligibility_request': EligibilityCheckRequestObjectToJSON(value.eligibility_request),
        'coverage_priority': value.coverage_priority,
        'member_identifier_type': value.member_identifier_type,
    };
}

